export enum MolTableActionLinkTypeEnum {
  PRIMARY = "primary",
  DANGER = "danger",
}
